import { decodeLandingSeed } from "./compact-landing-seed.mjs";

/** Mirror entry-server's inventory seed, not the outer document envelope. */
export function countryHydrationSnapshot(wire, pathname, notFoundPath = null) {
  // Branded 404s share the SSR shell, not a homepage's inventory contract.
  // Bind the data-free snapshot to the exact server-stamped missing route.
  if (notFoundPath !== null) {
    if (notFoundPath !== pathname)
      throw Error("Not-found hydration requires this document's pathname");
    return { pathname, notFound: true };
  }
  const documentSeed = decodeLandingSeed(wire);
  const inventory = documentSeed?.fixedInventory;
  if (documentSeed?.path !== pathname || inventory?.path !== pathname ||
      inventory?.brand !== "bookaclassic" || inventory?.state !== "ready") {
    throw Error("Country hydration requires this document's ready BAC inventory");
  }
  if (documentSeed.flags !== undefined) {
    const flags = documentSeed.flags;
    if (!flags || typeof flags !== "object" || Array.isArray(flags) ||
        !Object.values(flags).every(value => typeof value === "boolean")) {
      throw Error("Country hydration requires valid document flags");
    }
    return { pathname, seed: inventory, flags };
  }
  return { pathname, seed: inventory };
}
